import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, IResultadoItemProdutos } from "../../../model";
import { Button, Checkbox, Collapse, FormGroup, InputGroup, Tooltip } from "@blueprintjs/core";
import { MDBBtn } from "mdbreact";
import * as moment from "moment";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { formatCnpj } from "../../../utils";
import { toast } from "react-toastify";
const numeral = require("numeral");

var debounce = require('lodash.debounce');

interface Props {
  handleContestarLote: () => void;
  items: IResultadoItemProdutos[];
  modelo: string;
  empresa: IEmpresa;
  data: any;
}

interface State {
  handleContestarLote: () => void;
}

@observer
export class NaoContestadosTableRs extends React.Component<Props, State> {

  obs = observable({
    viewing: {} as IResultadoItemProdutos,
    estado: "RS" as string,
    fetchOptions: {} as any,
    filtrosAbertos: true as boolean
  })

  constructor(props) {
    super(props);

    this.state = {
      handleContestarLote: props.handleContestarLote,
    };

    this.obs.fetchOptions = debounce(this.handleQuery.bind(this), 800);
  }

  async handleQuery() {
    await ResultadoStore.handleResultMemoriaRsFiltered(ResultadoStore.obs.page_produto_rs, this.obs.estado);
  }

  async handleQueryFilters(e) {
    ResultadoStore.obs.page_produto_rs = 1;
    this.obs.fetchOptions();
  }

  handleContest(item: IResultadoItemProdutos) {
    ResultadoStore.obs.estado = this.obs.estado;
    AppStore.setContestarProduto(item);
  }

  handleContestarTodos() {
    ResultadoStore.selectAllContestarLoteRsNaoCalculados();
    ResultadoStore.obs.contestar_todos = true;
    ResultadoStore.obs.estado = this.obs.estado;
    this.state.handleContestarLote();
  }

  handleContestar() {
    ResultadoStore.obs.estado = this.obs.estado;
    this.state.handleContestarLote();
  }

  onSelect = async (item: any, checked: boolean) => {
    if (checked) {
      const aliquotasItem = item.aliquota_icms_origem;

      if (ResultadoStore.obs.contestarItems.length > 0) {
        const primeira = ResultadoStore.obs.contestarItems[0];
        const aliquotasPrimeira = primeira.aliquota_icms_origem;

        if (aliquotasItem !== aliquotasPrimeira) {
          toast.warn("Este item possui alíquotas diferentes do primeiro item selecionado!", {});
          return;
        }
      }

      let data = {
        id: item._id,
        data: item.data,
        produtos: item.produtos,
        aliquota_icms_origem: item.aliquota_icms_origem,
      };
      ResultadoStore.setContestarItems(data);
    } else {
      ResultadoStore.deleteByIdContestarItems(item._id);
    }
  };

  onSelectAll = async (isSelect: boolean) => {
    if (isSelect) {
      const items = (ResultadoStore.obs.result_memoria_rs || [])
        .filter(item => !this.isProcessing(item._id));
      if (!items.length) return;

      const primeiraAliquotas = items[0].aliquota_icms_origem;
      const itensFiltrados = items.filter(item => item.aliquota_icms_origem === primeiraAliquotas);

      let data = itensFiltrados.map(item => ({
        id: item._id,
        data: item.data,
        produtos: item.produtos,
        aliquota_icms_origem: item.aliquota_icms_origem,
      }));
      ResultadoStore.setContestarItemsListNao(data);
    } else {
      ResultadoStore.resetContestarItems();
    }
  };

  isSelected(id: string) {
    return ResultadoStore.obs.contestarItems?.some(v => v.id === id) || false;
  }

  isProcessing(id: string) {
    return ResultadoStore.obs.itens_processando.indexOf(id) !== -1;
  }

  isAllSelected() {
    const selectable = (ResultadoStore.obs.result_memoria_rs || [])
      .filter(item => !this.isProcessing(item._id));
    if (!selectable.length) return false;
    return selectable.every(item => this.isSelected(item._id));
  }

  renderActions(item: any) {
    const niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    const isDisabled = niveis_acesso.indexOf("c2") === -1;

    if (!AppStore.obs1.usuario) return null;

    if (this.isProcessing(item._id)) {
      return (
        <div className="detalhamento-card-actions">
          <Tooltip content="Processando...">
            <img src="/images/icone-relogio.png" width={24} />
          </Tooltip>
        </div>
      );
    }

    return (
      <div className="detalhamento-card-actions">
        {!isDisabled && (
          <Tooltip content="Contestar">
            <button className="detalhamento-action-btn" onClick={() => this.handleContest(item)}>
              <img src="/images/contestar.png" width={20} />
            </button>
          </Tooltip>
        )}
      </div>
    );
  }

  renderCard(item: any) {
    const id = item._id;
    const selected = this.isSelected(id);
    const isProcessing = this.isProcessing(id);

    const cardClasses = [
      "detalhamento-card",
      selected ? "card-selected" : "",
    ].filter(Boolean).join(" ");

    const classificacaoNome = (item.classificacao_nome && item.classificacao_nome.startsWith("1"))
      ? item.classificacao_nome.substring(0, 4)
      : "Sem";

    return (
      <div key={id} className={cardClasses}>
        {/* Header */}
        <div className="detalhamento-card-header">
          <div className="detalhamento-card-header-left">
            {!isProcessing && (
              <Checkbox
                checked={selected}
                onChange={(e) => this.onSelect(item, (e.target as HTMLInputElement).checked)}
                style={{ marginBottom: 0 }}
              />
            )}
            <span className="detalhamento-card-descricao">
              {item.descricao?.toUpperCase()}
            </span>
          </div>
          {this.renderActions(item)}
        </div>

        {/* Body */}
        <div className="detalhamento-card-body">
          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Série / Nota</span>
            <span className="detalhamento-field-value">
              {item.serie_nota} / {item.num_nota || ""} - {item.num_item}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Emissão</span>
            <span className="detalhamento-field-value">{moment(item.data).format("DD/MM/YYYY")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">NCM</span>
            <span className="detalhamento-field-value">{item.ncm}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CEST</span>
            <span className="detalhamento-field-value">{item.cest || "Sem CEST"}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CNPJ</span>
            <span className="detalhamento-field-value">{item.empresa ? formatCnpj(item.empresa.cnpj) : "-"}</span>
          </div>

          <div className="detalhamento-field detalhamento-field-lg">
            <span className="detalhamento-field-label">Razão Social</span>
            <span className="detalhamento-field-value">{item.empresa?.razao_social || "-"}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Produto</span>
            <span className="detalhamento-field-value">
              {numeral(parseFloat(item.valor_produto) || 0).format("0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">ICMS Class.</span>
            <span className="detalhamento-field-value">{classificacaoNome}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Alíq. Origem</span>
            <span className="detalhamento-field-value">
              {item.aliquota_icms_origem ? `${item.aliquota_icms_origem}%` : "-"}
            </span>
          </div>

          <div className="detalhamento-field detalhamento-field-lg">
            <span className="detalhamento-field-label">Chave</span>
            <span className="detalhamento-field-value" style={{ wordBreak: "break-all", fontSize: 11 }}>
              {item.chave || "-"}
            </span>
          </div>
        </div>
      </div>
    );
  }

  public render() {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    let selectedItemCaption = ResultadoStore.selectedCount == 1 ? "item" : "itens";

    const items = ResultadoStore.obs.result_memoria_rs || [];
    const allSelected = this.isAllSelected();
    const totalItems = items.length;
    const selectedCount = ResultadoStore.obs.contestarItems?.length || 0;

    return (
      <>
        <div style={{ width: "100%", display: "inline-block", marginBottom: 10 }}>
          {AppStore.obs1.usuario && (
            <div style={{ display: "flex" }}>
              <div style={{ width: 300, float: 'left', marginRight: 10 }}>
                <Tooltip
                  content={`Contestar ${ResultadoStore.obs.contestar_todos
                    ? ResultadoStore.obs.result_memoria_rs_count
                    : ResultadoStore.selectedCount
                    } ${selectedItemCaption}`}
                  disabled={ResultadoStore.selectedCount == 0}
                >
                  <Button
                    className="btncontestarWidth"
                    disabled={ResultadoStore.selectedCount == 0 ||
                      niveis_acesso.indexOf("c2") == -1}
                    icon="issue"
                    onClick={() => this.handleContestar()}
                  >
                    Contestar Selecionados
                  </Button>
                </Tooltip>
              </div>
              <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.handleQuery()}>Atualizar</MDBBtn>
            </div>
          )}
        </div>

        <br /><br />

        <div className="detalhamento-filtros">
          <div className="detalhamento-filtros-header" onClick={() => this.obs.filtrosAbertos = !this.obs.filtrosAbertos}>
            <span className="detalhamento-filtros-title">
              Filtros
              {Object.values(ResultadoStore.obs.filters_nao_contestados).filter((v: string) => v?.trim()).length > 0 && (
                <span className="detalhamento-filtros-badge">
                  {Object.values(ResultadoStore.obs.filters_nao_contestados).filter((v: string) => v?.trim()).length}
                </span>
              )}
            </span>
            <span className={`detalhamento-filtros-toggle ${this.obs.filtrosAbertos ? "open" : ""}`}>
              {this.obs.filtrosAbertos ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </span>
          </div>
          <Collapse isOpen={this.obs.filtrosAbertos}>
            <div className="detalhamento-filtros-grid" style={{ paddingTop: 14 }}>
              <FormGroup label="Número Nota" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Número Nota" value={ResultadoStore.obs.filters_nao_contestados.filterNota} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterNota = e.target.value)} />
              </FormGroup>

              <FormGroup label="Número Item" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Número Item" value={ResultadoStore.obs.filters_nao_contestados.filterItem} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterItem = e.target.value)} />
              </FormGroup>

              <FormGroup label="NCM" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="NCM" value={ResultadoStore.obs.filters_nao_contestados.filterNcm} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterNcm = e.target.value)} />
              </FormGroup>

              <FormGroup label="CEST" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="CEST" value={ResultadoStore.obs.filters_nao_contestados.filterCest} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterCest = e.target.value)} />
              </FormGroup>

              <FormGroup label="CNPJ" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="CNPJ" value={ResultadoStore.obs.filters_nao_contestados.filterDestino} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterDestino = e.target.value.replace(/[^0-9]/g, ''))} />
              </FormGroup>

              <FormGroup label="Descrição" className="filtro-lg" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Descrição" value={ResultadoStore.obs.filters_nao_contestados.filterDescricao} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterDescricao = e.target.value)} />
              </FormGroup>

              <FormGroup label="Chave" className="filtro-lg" style={{ marginBottom: 0 }}>
                <InputGroup placeholder="Chave" value={ResultadoStore.obs.filters_nao_contestados.filterChave} onChange={(e) => this.handleQueryFilters(ResultadoStore.obs.filters_nao_contestados.filterChave = e.target.value)} />
              </FormGroup>
            </div>
          </Collapse>
        </div>

        <div className="detalhamento-container">
          <div className="detalhamento-select-all">
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Checkbox
                checked={allSelected}
                indeterminate={selectedCount > 0 && !allSelected}
                onChange={() => {
                  if (selectedCount > 0) {
                    this.onSelectAll(false);
                  } else {
                    this.onSelectAll(true);
                  }
                }}
                style={{ marginBottom: 0 }}
              />
              <span>
                {selectedCount > 0
                  ? `${selectedCount} de ${totalItems} selecionado(s)`
                  : `${totalItems} resultado(s)`
                }
              </span>
            </div>
          </div>

          {items.map((item: any) => this.renderCard(item))}
        </div>
      </>
    );
  }
}

export default NaoContestadosTableRs;
